import React from 'react';
import '@ant-design/compatible/assets/index.css';
import {
  Row,
  Form,
} from 'antd';
import PropTypes from 'prop-types';

import OnTraccrTextInput from '../../common/inputs/OnTraccrTextInput';
import colors from '../../constants/Colors';
import OnTraccrButton from '../../common/buttons/OnTraccrButton';
import BorderlessButton from '../../common/buttons/BorderlessButton';

const animationDuration = 0.5;

export default function RedesignLoginForm({
  handleSubmit,
  isReset,
  accentColor = colors.ONTRACCR_RED,
  hideForgotPassword,
  onResetButtonClicked,
  error,
}) {
  return (
    <Form onFinish={handleSubmit} className="login-form">
      <div className="login-welcome-text">Welcome back!</div>
      <div className="login-header">Login to your Account</div>
      { error && !isReset && (
        <div className="login-error-message">
          {error}
        </div>
      )}
      <div className="login-form-input-label">Username</div>
      <Form.Item
        name="username"
        style={{
          marginBottom: isReset ? 0 : 24,
        }}
      >
        <OnTraccrTextInput
          placeholder="Your username"
          prefixCls="login-redesign-input ant-input" // Override child input class
        />
      </Form.Item>
      { !isReset && (
        <div className="login-form-input-label">Password</div>
      )}
      <Form.Item
        name="password"
        style={{
          marginBottom: 0,
          height: isReset ? 0 : 36,
          transition: `height ${animationDuration}s`,
        }}
      >
        <OnTraccrTextInput
          // Force password to hide again to prevent displaying raw pw when going back to login
          key={isReset}
          style={{
            height: isReset ? 0 : 36,
            opacity: isReset ? 0 : 1,
            transition: `height ${animationDuration}s, opacity ${animationDuration / 2}s`,
          }}
          password
          type="password"
          inputPrefixCls="login-redesign-input login-password-input ant-input" // Override child input class
        />
      </Form.Item>
      {!hideForgotPassword && (
        <Row type="flex" justify="end">
          <BorderlessButton
            className="login-forgot-password-button"
            title={isReset ? 'Back to Login' : 'Forgot password?'}
            onClick={onResetButtonClicked}
            showIcon={false}
          />
        </Row>
      )}
      <Row justify="center">
        <OnTraccrButton
          isRedesign
          title={isReset ? 'Reset Password' : 'Login'}
          style={{ width: '100%', fontWeight: 500, marginTop: 20 }}
          htmlType="submit"
        />
      </Row>
    </Form>
  );
}

RedesignLoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isReset: PropTypes.bool,
  accentColor: PropTypes.string,
};

RedesignLoginForm.defaultProps = {
  isReset: false,
  accentColor: colors.ONTRACCR_RED,
};